import Accordion from './src/components/Accordion/index';
import AlternatingTextAndImages from './src/components/AlternatingTextAndImages/index';
import BlogRollPostItem from './src/components/BlogRoll/BlogRollPostItem';
import BlogRollPosts from './src/components/BlogRoll/BlogRollPosts';
import BlogRoll from './node_modules/tbk-components/src/components/BlogRoll/index.js';
import BlogRollPagination from './node_modules/tbk-components/src/components/BlogRoll/BlogRollPagination.js';
import BlogRollTile from './node_modules/tbk-components/src/components/BlogRoll/BlogRollTile.js';
import BlogRollWithFeaturedPost from './src/components/BlogRollWithFeaturedPost/index';
import Breadcrumb from './src/components/Breadcrumb/index';
import Careers from './src/components/Careers/index';
import CarouselHeroBanner from './src/components/CarouselHeroBanner/index';
import CommercialSolutions from './src/components/CommercialSolutions/index';
import ContentBar from './src/components/ContentBar/index';
import ContentContainer from './src/components/ContentContainer/index';
import CtaBar from './src/components/CtaBar/index';
import DonationsWeAccept from './src/components/DonationsWeAccept/index';
import FollowUs from './src/components/FollowUs/index';
import Footer from './src/components/Footer/index';
import Form from './src/components/Form/index';
import Newsletter from './src/components/Form/Newsletter';
import NewsletterCta from './src/components/Form/NewsletterCta';
import NewsletterFull from './src/components/Form/NewsletterFull';
import FullWidthImage from './src/components/FullWidthImage/index';
import Header from './src/components/Header/index';
import LocationNavPage from './src/components/Header/Mobile/LocationNavPage';
import MainNavMobile from './src/components/Header/Mobile/MainNavMobile';
import MainNavPage from './src/components/Header/Mobile/MainNavPage';
import ContentHeroBanner from './src/components/HeroBanner/ContentHeroBanner';
import HeroBanner from './src/components/HeroBanner/index';
import HeroBannerWithCtaBox from './src/components/HeroBannerWithCtaBox/index';
import HistoryTimeline from './src/components/HistoryTimeline/index';
import HorizontalRule from './src/components/HorizontalRule/index';
import ImageBar from './src/components/ImageBar/index';
import JoinUs from './src/components/JoinUs/index';
import AllLocations from './src/components/Location/AllLocations';
import Location from './src/components/Location/index';
import LocationMobileNav from './src/components/Location/LocationMobileNav';
import SingleLocation from './src/components/Location/SingleLocation';
import SingleLocationAdditional from './src/components/Location/SingleLocationAdditional';
import SingleLocationDonations from './src/components/Location/SingleLocationDonations';
import SingleLocationHeader from './src/components/Location/SingleLocationHeader';
import LocationTilesListing from './src/components/LocationTilesListing/index';
import LocationTile from './src/components/LocationTilesListing/LocationTile';
import MainHeroBanner from './src/components/MainHeroBanner/index';
import MainSearchSection from './src/components/MainSearchSection/index';
import ButtonGeolocate from './src/components/Map/ButtonGeolocate';
import Map from './src/components/Map/index';
import MegaMenu from './src/components/MegaMenu/index';
import MegaMenuMobile from './src/components/MegaMenu/Mobile/MegaMenuMobile';
import MultiStory from './src/components/MultiStory/index';
import PageNav from './src/components/PageNav/index';
import PrettyPDF from './src/components/PrettyPDF/index';
import SearchBar from './src/components/SearchBar/index';
import ShareOn from './src/components/ShareOn/index';
import ShopList from './src/components/ShopList/index';
import ShopCard from './src/components/ShopList/ShopCard';
import SimpleGallery from './src/components/SimpleGallery/index';
import SingleStory from './src/components/SingleStory/index';
import SoMuchMoreThanAStore from './src/components/SoMuchMoreThanAStore/index';
import Stat from './src/components/Stat/index';
import Stats from './src/components/Stats/index';
import Tags from './src/components/Tags/index';
import TeamModule from './src/components/TeamModule/index';
import TestimonialsCarousel from './src/components/TestimonialsCarousel/index';
import Video from './src/components/Video/index';
import VideoModal from './src/components/VideoModal/index';
import AlertBar from './node_modules/tbk-components/src/components/AlertBar/index.js';
import BasicElement from './node_modules/tbk-components/src/components/BasicElement/index.js';
import BlogRollFilterBar from './node_modules/tbk-components/src/components/BlogRoll/BlogRollFilterBar.js';
import BlogRollHero from './node_modules/tbk-components/src/components/BlogRoll/BlogRollHero.js';
import BlogRollPage from './node_modules/tbk-components/src/components/BlogRoll/BlogRollPage.js';
import BlogRollSingle from './node_modules/tbk-components/src/components/BlogRoll/BlogRollSingle.js';
import Button from './node_modules/tbk-components/src/components/Button/index.js';
import Container from './node_modules/tbk-components/src/components/Container/index.js';
import Image from './node_modules/tbk-components/src/components/Image/index.js';
import ImageAndContent from './node_modules/tbk-components/src/components/ImageAndContent/index.js';
import LogoBar from './node_modules/tbk-components/src/components/LogoBar/index.js';
import Nav from './node_modules/tbk-components/src/components/Nav/index.js';
import NavItem from './node_modules/tbk-components/src/components/Nav/NavItem.js';
import Offcanvas from './node_modules/tbk-components/src/components/Offcanvas/Offcanvas.js';
import OffcanvasBackButton from './node_modules/tbk-components/src/components/Offcanvas/OffcanvasBackButton.js';
import OffcanvasButton from './node_modules/tbk-components/src/components/Offcanvas/OffcanvasButton.js';
import RawHTML from './node_modules/tbk-components/src/components/RawHTML/index.js';
import Row from './node_modules/tbk-components/src/components/Row/index.js';

const components = {
	Accordion,
	AlternatingTextAndImages,
	BlogRollPostItem,
	BlogRollPosts,
	BlogRoll,
	BlogRollPagination,
	BlogRollTile,
	BlogRollWithFeaturedPost,
	Breadcrumb,
	Careers,
	CarouselHeroBanner,
	CommercialSolutions,
	ContentBar,
	ContentContainer,
	CtaBar,
	DonationsWeAccept,
	FollowUs,
	Footer,
	Form,
	Newsletter,
	NewsletterCta,
	NewsletterFull,
	FullWidthImage,
	Header,
	LocationNavPage,
	MainNavMobile,
	MainNavPage,
	ContentHeroBanner,
	HeroBanner,
	HeroBannerWithCtaBox,
	HistoryTimeline,
	HorizontalRule,
	ImageBar,
	JoinUs,
	AllLocations,
	Location,
	LocationMobileNav,
	SingleLocation,
	SingleLocationAdditional,
	SingleLocationDonations,
	SingleLocationHeader,
	LocationTilesListing,
	LocationTile,
	MainHeroBanner,
	MainSearchSection,
	ButtonGeolocate,
	Map,
	MegaMenu,
	MegaMenuMobile,
	MultiStory,
	PageNav,
	PrettyPDF,
	SearchBar,
	ShareOn,
	ShopList,
	ShopCard,
	SimpleGallery,
	SingleStory,
	SoMuchMoreThanAStore,
	Stat,
	Stats,
	Tags,
	TeamModule,
	TestimonialsCarousel,
	Video,
	VideoModal,
	AlertBar,
	BasicElement,
	BlogRollFilterBar,
	BlogRollHero,
	BlogRollPage,
	BlogRollSingle,
	Button,
	Container,
	Image,
	ImageAndContent,
	LogoBar,
	Nav,
	NavItem,
	Offcanvas,
	OffcanvasBackButton,
	OffcanvasButton,
	RawHTML,
	Row
};

export default components;
